import { actions } from "../../actions/members/members";

import * as setters from '../../components/site/features/profile/actions/setters';

export default function members( state, action ) {
    if( !state ) {
        return {
            otherProfile: {
                ui: {
                    isFetching: true,
                    isError: false,
                    guestMode: true,
                    hideToggle: true,
                }
            },
        };
    }

    const newState = { ...state };

    switch( action.type ) {
        case actions.SET_CURRENT_MEMBER: return setCurrentMember( newState, action.member );
        case actions.SET_MEMBERS: return setMembers( newState, action );
        case actions.SET_PREMIUM_MEMBERS: return setPremiumMembers( newState, action.premium_members );
        case actions.SET_SEARCH: return setMemberSearch( newState, action );
        case actions.GET_OTHER_PROFILE: return setOtherProfileInitial( newState, action );
        case actions.SET_OTHER_PROFILE: return setOtherProfile( newState, action );
        case actions.SET_OTHER_PICTURE: return setOtherProfilePicture( newState, action );
        case actions.SET_OTHER_CUSTOM_URL: return setOtherProfileUrl( newState, action );
        case actions.SET_OTHER_COUNTRIES: return setOtherProfileLocations( newState, action );
        case actions.SET_OTHER_USER_PERMISSIONS: return setOtherProfilePermissions( newState, action );
        case actions.SET_OTHER_INVESTMENTS_LIST: return setOtherProfileInvestments( newState, action );
        case actions.SET_OTHER_PROFILE_LOADED: return setOtherProfileLoaded( newState, action );
        case actions.DESTROY_OTHER_PROFILE: return destroyOtherProfile( newState, action );
        case actions.GET_MEMBERS: return getMembers( newState, action );
        case actions.CLEAR_MEMBERS: return clearMembers( newState, action );
        default: return state;
    }
}


function getMembers( newState, action ) {
    newState.members = action.members;

    return newState;
}

function setCurrentMember( newState, member ) {
    newState.current_member = member;

    return newState;
}

function setMembers( newState, action ) {

    newState.members = action.members;
    newState.pagination = action.pagination;
    newState.options = action.options;

    return newState;
}

function setMemberSearch( newState, action ) {
    newState.members = action.members;
    newState.pagination = action.pagination;

    return newState;
}

function setPremiumMembers( newState, premium ) {
    newState.premium = premium;

    return newState;
}

function setOtherProfileInitial( newState, action ){

    const otherProfile = {};

    delete action.type;
    otherProfile.ui = action;

    newState.otherProfile = otherProfile;

    return newState;

}

function setOtherProfile( newState, action) {

    const otherProfileNormalized = { ...newState.otherProfile };

    otherProfileNormalized.headline = setters.setHeadline( action.otherProfile );

    otherProfileNormalized.name = setters.setName( action.otherProfile );

    otherProfileNormalized.locations = setters.setLocations( action.otherProfile );

    otherProfileNormalized.industries = setters.setIndustries( action.otherProfile );

    otherProfileNormalized.visibility = setters.setVisibility( action.otherProfile );

    otherProfileNormalized.summary = setters.setSummary( action.otherProfile );

    otherProfileNormalized.experience = setters.setExperience( action.otherProfile );

    otherProfileNormalized.endorsements = setters.setEndorsements( action.otherProfile );

    otherProfileNormalized.education = setters.setEducation( action.otherProfile );

    otherProfileNormalized.certificates = setters.setCertificates( action.otherProfile );

    otherProfileNormalized.press = setters.setPress( action.otherProfile );

    otherProfileNormalized.awards = setters.setAwards( action.otherProfile );

    otherProfileNormalized.publications = setters.setPublications( action.otherProfile );

    otherProfileNormalized.forms = setters.setForms();

    otherProfileNormalized.markets = setters.setMarkets( action.otherProfile );

    otherProfileNormalized.expertise = setters.setExpertise( action.otherProfile );

    otherProfileNormalized.sectors = setters.setSectors( action.otherProfile );

    otherProfileNormalized.investments = setters.setInvestments( action.otherProfile );

    otherProfileNormalized.rating = setters.setRating( action.otherProfile );

    otherProfileNormalized.customUrl = {};

    newState.otherProfile = otherProfileNormalized;

    return newState;
}

function setOtherProfilePicture( newState, action ){

    const otherProfile = { ...newState.otherProfile };

    delete action.type;

    otherProfile.picture = action;

    newState.otherProfile = otherProfile;

    return newState;

}

function setOtherProfileUrl( newState, action ){

    const otherProfile = { ...newState.otherProfile };

    delete action.type;
    otherProfile.customUrl = action;

    newState.otherProfile = otherProfile;

    return newState;

}

function setOtherProfileLocations( newState, action ){

    const otherProfile = { ...newState.otherProfile };
    const otherProfileLocations = otherProfile.locations;

    delete action.type;
    otherProfileLocations.countries = action.countries;

    newState.otherProfile = otherProfile;

    return newState;

}

function setOtherProfilePermissions( newState, action ){

    const otherProfile = { ...newState.otherProfile };

    delete action.type;
    otherProfile.permissions = action;

    newState.otherProfile = otherProfile;

    return newState;

}

function setOtherProfileInvestments( newState, action ){

    const otherProfile = { ...newState.otherProfile };
    const otherProfileUi = otherProfile.ui;

    delete action.type;
    otherProfileUi.ranges = action.ranges;

    newState.otherProfile = otherProfile;

    return newState;

}

function setOtherProfileLoaded( newState, action ){

    const otherProfile = { ...newState.otherProfile };
    const otherProfileUi = otherProfile.ui;

    delete action.type;
    otherProfileUi.isFetching = action.isFetching;
    otherProfileUi.isError = action.isError;
    otherProfileUi.personId = action.personId;

    newState.otherProfile = otherProfile;

    return newState;

}

function destroyOtherProfile( newState, action ) {

        newState.otherProfile = {
            ui: {
                isFetching: true,
                isError: false,
                guestMode: true,
                hideToggle: true,
            }
        };

        return newState;
}

function clearMembers(newState, action) {
      newState.members = null;
      return newState;
};



// WEBPACK FOOTER //
// src/client/reducers/members/members.js